import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class InvoiceService extends CentralService {
  protected resource: string = "index/invoice";
}
